<!--
 * @Description: 查看考生
 * @Author: 王丽欣
 * @Date: 2023-04-27 16:14:30.193
 * @LastEditors: PF
 * @LastEditTime: 2025-07-17 15:13:55
-->
<template>
    <div>
      <el-dialog class="wp70 hp80" :model-value="openChaKanKaoSheng" :close-on-click-modal="false" :show-close="false" destroy-on-close>
        <template #header>
          <div class="header-left">
            <el-icon class="header-icon">
              <Edit />
            </el-icon>
            <span class="header-title">查看考生</span>
          </div>
          <div class="header-right">
            <el-button type="info" text @click="closeWindow('openChaKanKaoSheng', emits, false)">
              <el-icon>
                <Close />
              </el-icon>
            </el-button>
          </div>
        </template>
        <el-table :data="ksccData" height="100%" border stripe>
          <el-table-column label="序号" type="index" width="80" fixed align="center" />
          <el-table-column label="考号" prop="kh" fixed align="center" min-width="70" />
          <el-table-column label="姓名" prop="xm" fixed align="center" min-width="90" />
          <el-table-column label="学号" prop="xh" fixed align="center" min-width="70" />
          <el-table-column label="专业" prop="zymc" align="center" min-width="140"/>
          <el-table-column label="年级" prop="njmc" align="center" min-width="100"/>
          <el-table-column label="班级" prop="bjmc" align="center" min-width="180"/>
        </el-table>
      </el-dialog>
    </div>
  </template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { actionPost, closeWindow } from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'

const props = defineProps({
  openChaKanKaoSheng: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openChaKanKaoSheng', 'ReturnData'])

const row = ref()
const ksccData = ref([])
const initList = async () => {
  const o = {
    url: '/api/v2/jiaowu/kaowukaoshijihuapaikao/kaosheng',
    data: { kcid: row.value.id, order: 'kccdmc', sort: 'asc' }
  }
  actionPost(o).then((res) => {
    if (res.code === 200) {
      ksccData.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openChaKanKaoSheng,
  () => {
    if (props.openChaKanKaoSheng) {
      row.value = props.row
      initList()
    }
  },
  { deep: true, immediate: true }
)

</script>
